"use client";

import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";
import { HOME_SERVICE_ITEMS } from "../home.data";

// * ─── Services Overview ──────────────────────────────────────────────────────
export function HomeServicesSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-4">
            {t("services.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 max-w-2xl mx-auto">
            {t("services.subtitle")}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {HOME_SERVICE_ITEMS.map((service, index) => (
            <GlassCard key={index} className="p-6 group cursor-pointer">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-walnut-500 to-walnut-700 dark:from-walnut-600 dark:to-walnut-800 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <service.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-walnut-900 dark:text-white mb-3">
                {t(service.titleKey)}
              </h3>
              <p className="text-walnut-700 dark:text-walnut-300">
                {t(service.descriptionKey)}
              </p>
            </GlassCard>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            href="/products"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-[33px] bg-gradient-to-r from-walnut-600 to-walnut-700 dark:from-walnut-500 dark:to-walnut-600 text-white font-semibold hover:shadow-lg hover:shadow-walnut-500/30 transition-all duration-300 hover:scale-105"
          >
            {t("services.viewAll")}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
